import * as gzOuterContainerDirective from './outer-container.directive';

export default angular.module('gazelle.components.outerContainer', [
])
  .directive(gzOuterContainerDirective.name, gzOuterContainerDirective.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/outer-container/outer-container.module.js